import { useStatsig } from '@atlassian/mpac-feature-flags';
import { AppInstallPermission } from '@atlassian/mpac-services-client';
import React from 'react';
import SiteSelectorError from './SiteSelectorError';
import { jsx as _jsx } from "react/jsx-runtime";
const SiteSelectorPermissionErrorSection = props => {
  const {
    installPermission,
    isFreeApp,
    appHasMultiInstanceLicense
  } = props;
  const {
    enableMILCustomerSupport
  } = useStatsig();
  if (installPermission === AppInstallPermission.CAN_INSTALL_FREE_AND_PAID) {
    if (enableMILCustomerSupport() && appHasMultiInstanceLicense) {
      return /*#__PURE__*/_jsx(SiteSelectorError.AppHasMultiInstanceLicenseExists, {});
    }
    return null;
  } else if (installPermission === AppInstallPermission.CANNOT_INSTALL) {
    return /*#__PURE__*/_jsx(SiteSelectorError.CannotInstallAnyApps, {});
  } else if (installPermission === AppInstallPermission.CAN_INSTALL_FREE_ONLY) {
    return isFreeApp ? null : /*#__PURE__*/_jsx(SiteSelectorError.CannotInstallPaidApps, {});
  } else {
    return /*#__PURE__*/_jsx(SiteSelectorError.Unknown, {});
  }
};
export default SiteSelectorPermissionErrorSection;